import { Middleware } from '@nuxt/types'

const REGISTER_REFERER = 'registerReferer'

const POPUP_KEY = 'popup'
const POPUP_UNLOCK_PRO = 'unlock-pro'

const retainReferer: Middleware = ({ route, redirect, $auth }) => {
  const popup = route.query.p || null
  if (popup === POPUP_UNLOCK_PRO) {
    localStorage.setItem(POPUP_KEY, POPUP_UNLOCK_PRO)
  }

  // --- look for the referer in localStorage --- //
  if ($auth.loggedIn) {
    const registerReferer = localStorage.getItem(REGISTER_REFERER)
    // means user came back after completing the register process
    if (registerReferer !== null) {
      localStorage.removeItem(REGISTER_REFERER)
      return redirect(registerReferer)
    }

    return
  }

  // --- parse url params and keep the referer before redirect --- //
  const action = route.query.a || null

  // save current url as referer
  if (action === 'register') {
    localStorage.setItem(REGISTER_REFERER, route.path)
    window.location.href = '/register'
    // promise is required to stop the flow, prevent running other middleware and rendering, prevent short clipping
    return new Promise(() => {})
  }
}

export const needToPreopenUnlockProPopup = () => {
  if (localStorage.getItem(POPUP_KEY) === POPUP_UNLOCK_PRO) {
    localStorage.removeItem(POPUP_KEY)
    return true
  }
  return false
}

export default retainReferer
